/*jshint loopfunc: true */
define('editor/edit/layers/edit/directions',['./layerBase', 'jquery', 'knockout', 'knockout-mapping', 'plugins/http', 'durandal/app', 'no-ui-slider', 'tinycolorpicker'], function (layerBase, $, ko, komapping, http, app, noUiSlider) {
    var viewmodel = function() {
        var self = this;
        
        var moduleId = self.__moduleId__;
        self.base = new layerBase();
        $.extend(self, self.base);
        self.__moduleId__ = moduleId;

        self.icons = ko.observableArray([]);
        
        self.defaultStrokeColor = '#0247FE';
        self.defaultStrokeWeight = 5;
        self.defaultStrokeOpacity = 0.5;
      
        self.strokeColor = ko.observable();
        self.selectedStrokeWeight = ko.observableArray([]);
        self.opacity = ko.observable();
        self.selectedStartIcon = ko.observable('/content/icons/default/Markers/start.svg');
        self.selectedStartIconHidden = ko.observable(false);
        self.selectedEndIcon = ko.observable('/content/icons/default/Markers/end.svg');
        self.selectedEndIconHidden = ko.observable(false);
        self.selectedWaypointIcon = ko.observable('/content/icons/default/Markers/capitalcity_02.svg');
        self.selectedWaypointIconHidden = ko.observable(false);
        self.markersLen = 0;

      // extra SVG properties:
      self.selectedStartIconSize = ko.observableArray(['normal']);
      self.startMarkerIconColour = ko.observable('#FFFFFF');
      self.startMarkerPaddleColour = ko.observable('#0AA54A');
      self.startMarkerPaddleVisible = ko.observable(true);

      self.selectedWaypointIconSize = ko.observableArray(['normal']);
      self.waypointMarkerIconColour = ko.observable('#FFFFFF');
      self.waypointMarkerPaddleColour = ko.observable('#808080');
      self.waypointMarkerPaddleVisible = ko.observable(true);

      self.selectedEndIconSize = ko.observableArray(['normal']);
      self.endMarkerIconColour = ko.observable('#FFFFFF');
      self.endMarkerPaddleColour = ko.observable('#0AA54A');
      self.endMarkerPaddleVisible = ko.observable(true);

        self.activate = function (editorMapId, layer, backToListFunc) {
            self.base.activate(editorMapId, layer, backToListFunc);
            self.editorMapId = editorMapId;
            self.layer = layer;
            self.markersLen = self.layer.state().waypoints.length;
            
            self.getIcons()
                .then(self.processIcons)
                .fail(app.showError);

            self.strokeColor(self.layer.state().strokeColor ? self.layer.state().strokeColor : self.defaultStrokeColor);
            self.selectedStrokeWeight.push('' + (self.layer.state().strokeWeight ? self.layer.state().strokeWeight : self.defaultStrokeWeight));
            self.opacity((self.layer.state().strokeOpacity ? self.layer.state().strokeOpacity : self.defaultStrokeOpacity) * 100);

            for (var i = 0; i < self.markersLen; i++) {
              var icon = self.layer.state().waypoints[i].icon,
                iconHidden = self.layer.state().waypoints[i].iconHidden,
                iconColour = self.layer.state().waypoints[i].iconColour,
                iconSize = self.layer.state().waypoints[i].iconSize,
                paddleColour = self.layer.state().waypoints[i].paddleColour,
                paddleVisible = self.layer.state().waypoints[i].paddleVisible;

              if (!icon) {
                continue;
              }

                if (i === 0) {
                    self.selectedStartIcon(icon);
                    self.selectedStartIconHidden(iconHidden);
                    self.selectedStartIconSize = ko.observableArray([iconSize]);
                    self.startMarkerIconColour = ko.observable(iconColour);
                    self.startMarkerPaddleColour = ko.observable(paddleColour);
                    self.startMarkerPaddleVisible = ko.observable(paddleVisible);
                } else if (i === self.markersLen - 1) {
                    self.selectedEndIcon(icon);
                    self.selectedEndIconHidden(iconHidden);
                    self.selectedEndIconSize = ko.observableArray([iconSize]);
                    self.endMarkerIconColour = ko.observable(iconColour);
                    self.endMarkerPaddleColour = ko.observable(paddleColour);
                    self.endMarkerPaddleVisible = ko.observable(paddleVisible);
                } else {
                    self.selectedWaypointIcon(icon);
                    self.selectedWaypointIconHidden(iconHidden);
                    self.selectedWaypointIconSize = ko.observableArray([iconSize]);
                    self.waypointMarkerIconColour = ko.observable(iconColour);
                    self.waypointMarkerPaddleColour = ko.observable(paddleColour);
                    self.waypointMarkerPaddleVisible = ko.observable(paddleVisible);
                }
            }

            self.changes = ko.computed(function () {
                // want to be notified of changes to these properties
                return self.strokeColor() +
                  self.selectedStrokeWeight()[0] +
                  self.opacity() +
                  self.selectedStartIcon() +
                  self.selectedEndIcon() +
                  self.selectedWaypointIcon() +
                  self.selectedStartIconHidden() +
                  self.selectedEndIconHidden() +
                  self.selectedWaypointIconHidden() +

                // svg properties
                  self.selectedStartIconSize()[0] +
                  self.startMarkerIconColour() +
                  self.startMarkerPaddleVisible() +
                  self.startMarkerPaddleColour() +

                  self.selectedWaypointIconSize()[0] +
                  self.waypointMarkerIconColour() +
                  self.waypointMarkerPaddleVisible() +
                  self.waypointMarkerPaddleColour() + 

                  self.selectedEndIconSize()[0] +
                  self.endMarkerIconColour() +
                  self.endMarkerPaddleVisible() +
                  self.endMarkerPaddleColour();
            });

            self.changes.subscribe(function () {
                // update layer observables and notify
                // the first feature should always be the polyline, followed by 2 marker layers representing start and end locations
                var polyline = self.layer.state();
                polyline.strokeColor = self.strokeColor();
                polyline.strokeOpacity = self.opacity() / 100;
                polyline.strokeWeight = self.selectedStrokeWeight()[0];

                for (var j = 0; j < self.markersLen; j++) {
                    var waypoint = self.layer.state().waypoints[j];

                    if (j === 0) {
                        waypoint.icon = self.selectedStartIcon();
                        waypoint.iconHidden = self.selectedStartIconHidden();

                        waypoint.iconSize      = self.selectedStartIconSize()[0];
                        waypoint.iconColour    = self.startMarkerIconColour();
                        waypoint.paddleVisible = self.startMarkerPaddleVisible();
                        waypoint.paddleColour  = self.startMarkerPaddleColour();
                    } else if (j === self.markersLen - 1) {
                        waypoint.icon = self.selectedEndIcon();
                        waypoint.iconHidden = self.selectedEndIconHidden();

                        waypoint.iconSize      = self.selectedEndIconSize()[0];
                        waypoint.iconColour    = self.endMarkerIconColour();
                        waypoint.paddleVisible = self.endMarkerPaddleVisible();
                        waypoint.paddleColour  = self.endMarkerPaddleColour();
                    } else {
                        waypoint.icon = self.selectedWaypointIcon();
                        waypoint.iconHidden = self.selectedWaypointIconHidden();

                        waypoint.iconSize      = self.selectedWaypointIconSize()[0];
                        waypoint.iconColour    = self.waypointMarkerIconColour();
                        waypoint.paddleVisible = self.waypointMarkerPaddleVisible();
                        waypoint.paddleColour  = self.waypointMarkerPaddleColour();
                    }
                }

                app.trigger("layers:updated", [self.layer]);
            });
        };
        
        self.getIcons = function () {
            var url = '/api/editor/icons';

            return http.get(url);
        };
        
        self.processIcons = function (response) {
            // group icons into category heirarchy
            var icons = response.data.icons;
            var categories = ko.utils.arrayMap(icons, function (icon) {
                return icon.categoryName;
            });

            var uniqueCategories = ko.utils.arrayGetDistinctValues(categories).sort();
            var categoriesLen = uniqueCategories.length;

            for (var i = 0; i < categoriesLen; i++) {
                var catName = uniqueCategories[i];
                var groupedIconsByCategory = {
                    name: catName,
                    icons: ko.observableArray([])
                };

                var categoryIcons = ko.utils.arrayFilter(icons, function (icon) {
                    return icon.categoryName === catName;
                });

                ko.utils.arrayPushAll(groupedIconsByCategory.icons(), categoryIcons);

                self.icons.push(groupedIconsByCategory);
            }
        };
        
        self.setStartIcon = function (icon) {
            self.selectedStartIcon(icon.filePath);
        };

        self.toggleStartIconVisibility = function () {
            self.selectedStartIconHidden(!self.selectedStartIconHidden());
        };

        self.setWaypointIcon = function (icon) {
            self.selectedWaypointIcon(icon.filePath);
        };
        
        self.toggleWaypointIconVisibility = function () {
            self.selectedWaypointIconHidden(!self.selectedWaypointIconHidden());
        };

        self.setEndIcon = function (icon) {
            self.selectedEndIcon(icon.filePath);
        };
        
        self.toggleEndIconVisibility = function () {
            self.selectedEndIconHidden(!self.selectedEndIconHidden());
        };
        
        self.compositionComplete = function () {
            // set up jQuery plugins etc..
            var slider = $('.slider'),
                sliderStart = self.opacity(),
                strokeColourPicker;

            noUiSlider.create(slider.get(0),
            {
                start: sliderStart,
                step: 1,
                tooltips: true,
                connect: "lower",
                orientation: "horizontal",
                range: {
                    'min': 0,
                    'max': 100
                },
                serialization: {
                    format: {
                        decimals: 0
                    }
                }
            });

            slider.get(0).noUiSlider.on('change', function () {
                var newValue = slider.get(0).noUiSlider.get();
                self.opacity(newValue);
            });

            strokeColourPicker = $('.color-picker-stroke').tinycolorpicker();
            strokeColourPicker.data().plugin_tinycolorpicker.setColor(self.strokeColor());
            strokeColourPicker.bind("change", function () {
                var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
                self.strokeColor(newColour);
            });

          // start
          var startIconPicker = $('.color-picker-start-icon').tinycolorpicker();
          var startIconMarker = $('.color-picker-start-marker').tinycolorpicker();

          startIconPicker.data().plugin_tinycolorpicker.setColor(self.startMarkerIconColour());
          startIconMarker.data().plugin_tinycolorpicker.setColor(self.startMarkerPaddleColour());

          startIconPicker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.startMarkerIconColour(newColour);
          });

          startIconMarker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.startMarkerPaddleColour(newColour);
          });

          // waypoints
          var waypointIconPicker = $('.color-picker-waypoint-icon').tinycolorpicker();
          var waypointIconMarker = $('.color-picker-waypoint-marker').tinycolorpicker();

          waypointIconPicker.data().plugin_tinycolorpicker.setColor(self.waypointMarkerIconColour());
          waypointIconMarker.data().plugin_tinycolorpicker.setColor(self.waypointMarkerPaddleColour());

          waypointIconPicker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.waypointMarkerIconColour(newColour);
          });

          waypointIconMarker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.waypointMarkerPaddleColour(newColour);
          });

          // end
          var endIconPicker = $('.color-picker-end-icon').tinycolorpicker();
          var endIconMarker = $('.color-picker-end-marker').tinycolorpicker();

          endIconPicker.data().plugin_tinycolorpicker.setColor(self.endMarkerIconColour());
          endIconMarker.data().plugin_tinycolorpicker.setColor(self.endMarkerPaddleColour());

          endIconPicker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.endMarkerIconColour(newColour);
          });

          endIconMarker.bind("change", function () {
            var newColour = $(this).data().plugin_tinycolorpicker.colorHex;
            self.endMarkerPaddleColour(newColour);
          });
        };
    };

    return viewmodel;
});

